import { useState } from 'react';
import { Box, Dialog, DialogContent, DialogContentText, Typography } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { StyledBox, StyledDrawer } from './styles';
import CustomButton from '../CustomButton';
import { getColors } from '../../../theme';

const colors = getColors();
export default function CustomDrawer({
  position = 'right',
  isOpen,
  handleClose,
  children,
  width = 450,
  drawerWidth,
  innerSx,
  disable,
  isDialogClose,
  setIsCloseDialog,
}) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { text } = colors;

  const handleOnClose = () => {
    if (!disable) {
      setDialogOpen(true);
      setDrawerOpen(true);
    } else {
      handleClose();
    }
  };

  const handleDialogeClose = async () => {
    await handleClose();
    setDialogOpen(false);
    setDrawerOpen(false);
  };

  const handleNochange = async () => {
    setDialogOpen(false);
    setDrawerOpen(false);
    if (setIsCloseDialog) {
      setIsCloseDialog(false);
    }
  };

  const handleIsDialogClose = () => {
    if (isDialogClose) {
      handleDialogeClose();
    } else {
      handleOnClose();
    }
  };

  return (
    <>
      <StyledDrawer
        PaperProps={{
          sx: { width: drawerWidth },
        }}
        anchor={position}
        open={isOpen || drawerOpen}
        onClose={handleIsDialogClose}
        style={{ zIndex: 1250 }}
      >
        <StyledBox
          sx={{ width: position === 'top' || position === 'bottom' ? 'auto' : width, ...innerSx }}
          role="presentation"
        >
          <Box
            sx={{
              position: 'fixed',
              right: 16,
              textAlign: 'right',
              cursor: 'pointer',
              zIndex: 120,
              overflow: 'hidden',
            }}
          >
            {!disable && <HighlightOffIcon onClick={handleIsDialogClose} />}
          </Box>
          {children}
        </StyledBox>
      </StyledDrawer>
      <Dialog
        open={dialogOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'end',
            position: 'relative',
            right: '7px',
            top: '7px',
          }}
        >
          <HighlightOffIcon onClick={handleDialogeClose} sx={{ cursor: 'pointer' }} />
        </Box>
        <DialogContent
          sx={{
            // Your custom styles here
            padding: '18px 23px',
          }}
        >
          <DialogContentText id="alert-dialog-description">
            <Typography color={text.primary} variant="h5" component="span">
              You have unsaved changes. Would you like to save them before proceeding?
            </Typography>
          </DialogContentText>
        </DialogContent>
        <Box
          mb={3}
          sx={{
            display: 'flex',
            gap: 2,
            justifyContent: 'right',
            alignItems: 'center',
            paddingRight: '30px',
          }}
        >
          <CustomButton variant="outlined" onClick={handleDialogeClose}>
            No
          </CustomButton>
          <CustomButton color="generalButton" onClick={handleNochange}>
            Yes
          </CustomButton>
        </Box>
      </Dialog>
    </>
  );
}
